const ScotlandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112293)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M32.1763 4.13437C28.8039 1.54211 24.5824 0 20.0001 0C15.4177 0 11.1962 1.54219 7.82373 4.13437L20.0001 16.3106L32.1763 4.13437Z"
        fill="#0052B4"
      />
      <path
        d="M4.1343 7.82324C1.54219 11.1957 0 15.4171 0 19.9995C0 24.5818 1.54219 28.8034 4.13437 32.1759L16.3107 19.9995L4.1343 7.82324Z"
        fill="#0052B4"
      />
      <path
        d="M7.82373 35.8657C11.1962 38.458 15.4177 40.0001 20.0001 40.0001C24.5824 40.0001 28.8039 38.4579 32.1764 35.8657L20.0001 23.6895L7.82373 35.8657Z"
        fill="#0052B4"
      />
      <path
        d="M35.8652 32.1757C38.4575 28.8033 39.9996 24.5818 39.9996 19.9995C39.9996 15.4171 38.4575 11.1957 35.8652 7.82324L23.689 19.9995L35.8652 32.1757Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112293">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ScotlandSvg;
